export const DEFAULT_HEADER = "Are you sure you want to delete?";
export const DEFAULT_DELETE_BUTTON_TEXT = "Delete";
export const DEFAULT_CANCEL_BUTTON_TEXT = "Cancel";
